import React, { memo } from 'react';
export const ComparisonTable = () => {
  return <div className="my-6" data-id="element-203">
      <ul className="space-y-4" data-id="element-204">
        <li className="bg-gray-50 p-3 rounded" data-id="element-205">
          <span className="font-bold" data-id="element-206">Pills and Capsules:</span> Who has time to
          plan ahead, find water, and risk a groggy morning meeting? Plus, when
          your stomach is churning with stress and caffeine, pills often sit
          undigested for hours.
        </li>
        <li className="bg-gray-50 p-3 rounded" data-id="element-207">
          <span className="font-bold" data-id="element-208">Melatonin:</span> Works great for
          teenagers with natural circadian rhythms. Fails miserably for stressed
          adults whose cortisol levels are through the roof. As one frustrated
          user put it: "Melatonin is like trying to whisper over a fire alarm."
        </li>
        <li className="bg-gray-50 p-3 rounded" data-id="element-209">
          <span className="font-bold" data-id="element-210">Prescription Sleep Medications:</span> Too
          risky when you need to be sharp for presentations and client calls.
          The side effects—memory problems, dependency, dangerous sleep
          behaviors—aren't worth it for most professionals.
        </li>
        <li className="bg-gray-50 p-3 rounded" data-id="element-211">
          <span className="font-bold" data-id="element-212">CBD Gummies:</span> Sugary candy that
          takes 45-60 minutes to work, if it works at all. By the time it kicks
          in, your sleep window has often closed.
        </li>
        <li className="bg-gray-50 p-3 rounded" data-id="element-213">
          <span className="font-bold" data-id="element-214">
            Herbal Teas and Traditional Remedies:
          </span>{' '}
          Require preparation time and multiple bathroom trips. Not practical
          for someone who travels frequently or works irregular hours.
        </li>
      </ul>
    </div>;
};